import {Component} from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Translate} from 'react-redux-i18n';

import * as snackbarsActions from '../../../actions/snackbars';
import organisationService from '../../../services/organisation/OrganisationService';
import {captureError} from '../../../utils/log';

export class SubcontractorRedirection extends Component {
  componentDidMount() {
    organisationService.getByRegistrationNumberAndCountry(this.props.match.params.registrationNumber, this.props.match.params.country)
      .then(organisation => {
        this.props.history.replace(`/subcontractor/${organisation.organisationId}`);
      }).catch(error => {
        captureError('organisationService.getByRegistrationNumberAndCountry', error);
        this.props.actions.addError(<Translate value="error.generic"/>);
      });
  }

  render() {
    return (
      <div className="loading-overlay"/>
    );
  }
}

SubcontractorRedirection.propTypes = {
  history: PropTypes.object.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      registrationNumber: PropTypes.string.isRequired,
      country: PropTypes.string.isRequired
    })
  }).isRequired,
  actions: PropTypes.object.isRequired
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({...snackbarsActions}, dispatch)
  };
}

export default withRouter(connect(null, mapDispatchToProps)(SubcontractorRedirection));
